import React from 'react'

const StrokeCreate = props => (
  <svg viewBox='0 0 100 100' {...props}>
    <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" >
      <path d="M360 986 c-81 -22 -144 -60 -215 -131 -108 -108 -145 -198 -145 -355 0 -157 37 -247 145 -355 115 -115 214 -151 389 -143 113 6 160 21 246 79 96 64 164 151 200 258 28 85 28 238 -1 323 -52 156 -198 292 -350 327 -60 14 -214 12 -269 -3z m238 -50 c165 -44 294 -173 338 -339 59 -223 -97 -468 -338 -533 -301 -80 -614 232 -534 533 34 129 126 244 242 302 102 51 193 63 292 37z"/>
      <path d="M480 665 l0 -135 -140 0 -140 0 0 -30 0 -30 140 0 140 0 0 -135 0 -135 25 0 25 0 0 135 0 135 135 0 135 0 0 30 0 30 -135 0 -135 0 0 135 0 135 -25 0 -25 0 0 -135z"/>
    </g>
  </svg>
)

export default StrokeCreate;
